import { useEffect } from 'react';

import type { EditorView } from '@atlaskit/editor-prosemirror/view';
import { useSmartCardContext } from '@atlaskit/link-provider/use-smart-card-context';

import { preloadSmartLinksForAI } from './resolve-smartlink';

const PRELOAD_DELAY_MS = 10_000;

export const SmartLinkAIPreload = ({ editorView }: { editorView: EditorView }) => {
	const { value: context } = useSmartCardContext();
	useEffect(() => {
		if (!context) {
			return;
		}
		const controller = new AbortController();
		const preload = () => {
			if (!editorView.isDestroyed && !controller.signal.aborted) {
				void preloadSmartLinksForAI(context, editorView.state.doc, controller.signal);
			}
		};
		let idleCallbackId: number | undefined;
		let animationFrameId: number | undefined;
		const timeoutId = window.setTimeout(() => {
			if (window.requestIdleCallback) {
				idleCallbackId = window.requestIdleCallback(preload);
			} else {
				animationFrameId = window.requestAnimationFrame(preload);
			}
		}, PRELOAD_DELAY_MS);
		return () => {
			controller.abort();
			window.clearTimeout(timeoutId);
			if (idleCallbackId !== undefined) {
				window.cancelIdleCallback(idleCallbackId);
			}
			if (animationFrameId !== undefined) {
				window.cancelAnimationFrame(animationFrameId);
			}
		};
	}, [context, editorView]);
	return null;
};
